import React, { useState } from 'react';
import TabulatorLifecycleDashboard from './TabulatorLifecycleDashboard';
import WorkflowComponentsController from './WorkflowComponentsController';
import type { AdvancedSearchConfig } from './WorkflowComponentsSearch';

export interface WorkflowComponentsTableProps {
    tenant?: string;
    titleSearch?: string;
    titleTable?: string;
    initialType?: string;
}

export const WorkflowComponentsTable: React.FC<WorkflowComponentsTableProps> = ({
    tenant,
    titleSearch = 'Workflow Components Search',
    titleTable = 'Workflow Components Table',
    initialType
}) => {
    // REMOVED: External WorkflowComponentsController - TabulatorLifecycleDashboard has its own search
    // The double/triple search issue was caused by rendering BOTH external and internal search
    return (
        <TabulatorLifecycleDashboard
            tabsMode="table-only"
            tenant={tenant}
            titleSearch={titleSearch}
            titleTable={titleTable}
            initialType={initialType}
            hideSearch={false}
            externalSearchConfig={null}
        />
    );
};

export default WorkflowComponentsTable;


